import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../../../../helpers/cell-validators'

export const validateMarginRatio: CellValidator = (record, token: GlobalToken) => {
    const marginRatio = record.calculated?.marginRatio
    const costOfAllCopies = record.calculated?.costOfAllCopies

    if (marginRatio === undefined) {
        return null
    }

    if (marginRatio < 1.45) {
        return {
            message: 'Коэффициент наценки меньше 1.45',
            bgColor: 'transparent',
            color: token.colorErrorText || token.colorError,
        }
    }

    if (costOfAllCopies !== undefined) {
        let shouldShowWarning = false

        if (costOfAllCopies > 16000 && costOfAllCopies <= 30000 && marginRatio < 2.3) {
            shouldShowWarning = true
        } else if (costOfAllCopies > 30000 && costOfAllCopies <= 50000 && marginRatio < 2.2) {
            shouldShowWarning = true
        } else if (costOfAllCopies > 50000 && costOfAllCopies <= 100000 && marginRatio < 2.1) {
            shouldShowWarning = true
        } else if (costOfAllCopies > 100000 && costOfAllCopies <= 170000 && marginRatio < 2.0) {
            shouldShowWarning = true
        } else if (costOfAllCopies > 170000 && costOfAllCopies <= 250000 && marginRatio < 1.9) {
            shouldShowWarning = true
        } else if (costOfAllCopies > 250000 && marginRatio < 1.8) {
            shouldShowWarning = true
        }

        if (shouldShowWarning) {
            return {
                message: 'Наценка ниже рекомендуемой для данной себестоимости',
                bgColor: 'transparent',
                color: token.colorWarningText || token.colorWarning ,
            }
        }
    }

    return null
}

